import React from "react";
import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";

import Icon from "../../UI/Icon/Icon";
import { IconButton } from "../../UI/IconButton/IconButton";

export const TransactionActions = ({
  contextMenuRef,
  transaction,
  setSelectedTransaction,
  showDeleteTransactionModal,
  showApproveTransactionModal,
  showEditTransactionModal,
  showRefundTicketsModal,
  resendTicketsHandler,
  resendInvoiceHandler,
  copyOfferLinkHandler,
  copyTicketLinkHandler,
}) => {
  const showContextMenu = (e, transaction) => {
    setSelectedTransaction(transaction);
    contextMenuRef.current.handleContextClick(e);
  };

  const handleAccordionClick = (transaction, e) => {
    if (transaction.seats && transaction.seats.length > 1) {
      e.target.parentNode.parentNode.parentNode.parentNode.classList.toggle(
        "active"
      );
    }
  };

  const canRefund =
    transaction.paymentStatus === 1 &&
    transaction.paymentType === 1 &&
    !transaction.refunded;

  const actionButtonClassName =
    transaction.paymentStatus === 0
      ? "btn-green IconButton green"
      : canRefund
      ? "btn-lavender IconButton lavender"
      : "IconButton gray";

  const actionButtonIconName =
    transaction.paymentStatus === 0
      ? "approve"
      : canRefund
      ? "refund"
      : "refund-gray";

  const editButtonClassName =
    transaction.paymentStatus === 0
      ? "btn-primary IconButton primary"
      : "IconButton gray";

  const editButtonIconName =
    transaction.paymentStatus === 0 ? "edit" : "edit-gray";

  const accordionClassName =
    "IconButton accordion-btn " +
    (transaction.seats && transaction.seats.length > 1
      ? "btn-primary"
      : "btn-default disable");

  return (
    <div className="buttons-block">
      <IconButton
        iconName="trash-red"
        className="btn-red IconButton red"
        onClick={(e) => {
          showDeleteTransactionModal(transaction);
        }}
      />
      <IconButton
        iconName={actionButtonIconName}
        className={actionButtonClassName}
        onClick={(e) => {
          if (transaction.paymentStatus === 0) {
            showApproveTransactionModal(transaction);
          }

          if (canRefund) {
            showRefundTicketsModal(transaction);
          }
        }}
      />
      <IconButton
        iconName={editButtonIconName}
        className={editButtonClassName}
        onClick={(e) => {
          if (transaction.paymentStatus === 0) {
            showEditTransactionModal(transaction);
          }
        }}
      />

      <ContextMenuTrigger
        ref={contextMenuRef}
        id={`menu-${transaction.id}`}
        key={transaction.id}
      >
        <IconButton
          iconName="options"
          className="btn-primary IconButton primary"
          onClick={(e) => showContextMenu(e, transaction)}
        />
      </ContextMenuTrigger>

      <ContextMenu id={`menu-${transaction.id}`}>
        <MenuItem onClick={resendTicketsHandler}>Resend tickets</MenuItem>
        <MenuItem onClick={resendInvoiceHandler}>Resend invoice</MenuItem>
        <MenuItem onClick={copyOfferLinkHandler}>Copy offer link</MenuItem>
        <MenuItem onClick={copyTicketLinkHandler}>Copy ticket link</MenuItem>
      </ContextMenu>

      <button
        className={accordionClassName}
        onClick={(e) => {
          handleAccordionClick(transaction, e);
        }}
      >
        <Icon name={"chevron"} />
      </button>
    </div>
  );
};
